var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4404 11.75H7.25C6.84 11.75 6.5 11.41 6.5 11C6.5 10.59 6.84 10.25 7.25 10.25H12.4405L10.7204 8.52994C10.4304 8.23994 10.4304 7.75994 10.7204 7.46994C11.0104 7.17994 11.4904 7.17994 11.7804 7.46994L14.7804 10.4699C15.0704 10.7599 15.0704 11.2399 14.7804 11.5299L11.7804 14.5299C11.6304 14.6799 11.4404 14.7499 11.2504 14.7499C11.0604 14.7499 10.8704 14.6799 10.7204 14.5299C10.4304 14.2399 10.4304 13.7599 10.7204 13.4699L12.4404 11.75Z",
    fill: "#1B75BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 21.75C4.82 21.75 0 16.93 0 11C0 5.07 4.82 0.25 10.75 0.25C16.68 0.25 21.5 5.07 21.5 11C21.5 16.93 16.68 21.75 10.75 21.75ZM10.75 1.75C5.65 1.75 1.5 5.9 1.5 11C1.5 16.1 5.65 20.25 10.75 20.25C15.85 20.25 20 16.1 20 11C20 5.9 15.85 1.75 10.75 1.75Z",
    fill: "#1B75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRightArrow);
export default __webpack_public_path__ + "static/media/circle_right_arrow.15180bd633ffe4c5ec3a9f7f3d6f4f32.svg";
export { ForwardRef as ReactComponent };